import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { FormDialog } from "@/components/hr/Shared";
import { pickable } from "@/components/hr/SubDialogs";
import { HR, errText } from "@/lib/hr";

// Upload (multipart) or edit metadata of an HR document. PDF / JPG / PNG up to 10 MB → Emergent object storage.
export function DocumentDialog({ cfg, employees, initial, defaultEmployee, onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const fields = [
    ...(initial ? [] : [{ k: "employee_id", l: "Employee", type: "select", opts: pickable(employees, initial, defaultEmployee).map((e) => [e.id, `${e.full_name} · ${e.employee_id}`]), req: true, def: defaultEmployee || "", span: 2 }]),
    { k: "document_type", l: "Document type", type: "select", opts: cfg.document_types, req: true, def: cfg.id_card_type || "Identification" }, { k: "document_name", l: "Document name", ph: "e.g. NRIC front & back" },
    { k: "issue_date", l: "Issue date", type: "date" }, { k: "expiry_date", l: "Expiry date", type: "date" }, { k: "remarks", l: "Remarks", span: 2 },
  ];
  const submit = async (v) => {
    if (initial) { const { data } = await axios.put(`${HR}/documents/${initial.id}`, v); toast.success("Document updated"); onSaved(data); return; }
    if (!file) throw { response: { data: { detail: "Choose a file to upload" } } };
    const fd = new FormData();
    Object.entries(v).forEach(([k, val]) => fd.append(k, val ?? ""));
    fd.append("file", file);
    try { const { data } = await axios.post(`${HR}/documents`, fd); toast.success("Document uploaded"); onSaved(data); }
    catch (e) { throw Object.assign(e, { response: { data: { detail: errText(e, "Upload failed") } } }); }
  };
  return (
    <FormDialog title={initial ? "Edit document details" : "Upload document"} desc="Stored privately in HR. Only HR users can open it." fields={fields} initial={initial || {}} onClose={onClose} submitLabel={initial ? "Save" : "Upload"} testid="document-dialog" onSubmit={submit}>
      {!initial && (
        <label className="flex items-center gap-3 rounded-xl border border-dashed border-slate-600 bg-slate-950/40 px-4 py-3 cursor-pointer hover:border-orange-400/60" data-testid="doc-file-label">
          <Upload className="w-5 h-5 text-orange-300 shrink-0" />
          <div className="min-w-0 text-sm"><div className="font-semibold truncate">{file ? file.name : "Choose PDF, JPG or PNG"}</div><div className="text-xs text-slate-500">{file ? `${(file.size / 1024 / 1024).toFixed(2)} MB` : "Up to 10 MB · IC, passport, permit, contract…"}</div></div>
          <input type="file" accept="application/pdf,image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="doc-file-input" />
        </label>
      )}
    </FormDialog>
  );
}
